import {
  CHANGE_USER_DATA, CREATE_ACCOUNT,
  FILL_DATA_FROM_PINCODE, FILL_EMAIL, FILL_MOBILE,
  FILL_USER_DATA, FILL_USERNAME,
  SHOW_ERROR_ON_NEW_ACCOUNT, TOGGLE_CHOICE,
  ACTION_SET_SESSION_ID_AND_CAPTCHA,
  EMPTY_USER_DATA
} from '../../../../constants/ActionTypes';

export const INITIAL_STATE = {
  showError: false,
  userName: '',
  password: '',
  securityQuestion: null,
  securityAnswer: '',
  language: null,
  firstName: '',
  lastName: '',
  gender: null,
  email: '',
  mobileNumber: '',
  dateOfBirth: null,
  occupation: null,
  maritalStatus: null,
  residentialAddress: '',
  residentialMobileNumber: '',
  pinCode: '',
  city: null,
  regionalState: null,
  postOffice: null,
  country: null,
  officeAddress: '',
  officeMobileNumber: '',
  officePinCode: '',
  officeCity: null,
  officeRegionalState: null,
  officePostOffice: null,
  officeCountry: null,
  officeCheckBoxEnabled: false,
  securityQuestionList: null,
  occupationList: null,
  cityList: null,
  postOfficeList: null,
  stateList: null,
  pinCodeErrorMessage: '',
  officeCityList: null,
  officePostOfficeList: null,
  officeStateList: null,
  officePinCodeErrorMessage: '',
  userNameErrorMessage: '',
  emailErrorMessage: '',
  mobileErrorMessage: '',
  regFlag: false,
  createAccountError: false,
  createAccountErrorMessage:'',
  enterCaptcha: '',
  irctcDowntimeError:null,
  captchaLoading:false,
  status:''
};

export default (state =INITIAL_STATE, action) => {
  switch (action.type) {
  case FILL_USER_DATA: {
    return { ...state, ...action.payload };
  }
  case CHANGE_USER_DATA: {
    return { ...state, ...action.payload };
  }
  case FILL_USERNAME: {
    return { ...state, ...action.payload };
  }
  case FILL_EMAIL: {
    return { ...state, ...action.payload };
  }
  case FILL_MOBILE: {
    return { ...state, ...action.payload };
  }
  case FILL_DATA_FROM_PINCODE: {
    return { ...state, ...action.payload };
  }
  case SHOW_ERROR_ON_NEW_ACCOUNT: {
    return { ...state, showError: action.payload };
  }
  case TOGGLE_CHOICE: {
    return { ...state, ...action.payload };
  }
  case CREATE_ACCOUNT: {
    return { ...state, ...action.payload };
  }
  case ACTION_SET_SESSION_ID_AND_CAPTCHA: {
    return { ...state, ...action.payload };
  }
  default:
    return state;
  }
};
